import { createAsyncThunk } from "@reduxjs/toolkit";
import apiInstance from "../../config/api";

function blobUrlToFile(blobUrl, filename) {
    return fetch(blobUrl)
        .then(response => response.blob())
        .then(blob => new File([blob], filename, { type: blob.type }));
}

export const createEvent = createAsyncThunk('event/create', async (data) => {
    try {
        const { eventDescription, location, eventName, startdateandtime, enddateandtime, image, category } = data ?? {}
        const formData = new FormData();
        // const uriParts = image.split('.');
        // const fileType = uriParts[uriParts.length - 1];
        const processedImage = await blobUrlToFile(image, `eventbanner.png`);


        formData.append('image', processedImage, processedImage.name);
        formData.append('eventDescription', eventDescription)
        formData.append('location', location)
        formData.append('eventName', eventName)
        formData.append('category', category)
        formData.append('startdateandtime', startdateandtime)
        formData.append('enddateandtime', enddateandtime)
        console.log(formData)

        const request = await apiInstance.post("/event/api/create/profile", formData);
        const response = request.data
        if (response.status === 'success') {
            return response.data
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const getMyEvent = createAsyncThunk('event/my-event', async () => {
    try {
        const request = await apiInstance.get('api/events/user');
        const response = request.data
        if (response.status === 'success') {
            return response.data
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const getSuggestedEvent = createAsyncThunk('event/suggested-event', async () => {
    try {
        const request = await apiInstance.get('api/events/get/suggested');
        const response = request.data
        if (response.status === 'success') {
            return response.data
        } else {
            throw new Error(response.message)
        }

    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const getInterestedEvent = createAsyncThunk('event/interested-event', async () => {
    try {
        const request = await apiInstance.get('/api/events/interested/events');
        const response = request.data;
        if (response.status === 'success') {
            return response.events
        } else {
            throw new Error(response.message)
        }

    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const getGoingEvent = createAsyncThunk('event/going-event', async () => {
    try {
        const request = await apiInstance.get('/api/events/going/events');
        const response = request.data;

        if (response.status === 'success') {
            return response.events
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const getInvitedEvent = createAsyncThunk('event/invited-event', async () => {
    try {
        const request = await apiInstance.get('/api/events/invitations/fetch');
        const response = request.data;

        if (response.message === 'Invitation gotten successfully') {
            return response.invitations
        } else {
            throw new Error(response.message)
        }

    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const toggleInterestedEvent = createAsyncThunk('event/toggle-interested-event', async (eventId) => {
    try {
        const request = await apiInstance.put(`api/events/toggle-intrested-status/${eventId}`);
        const response = request.data
        if (response.status === 'success') {
            return response.intrestedStatus
        } else {
            throw new Error(response.message)
        }

    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const toggleGoingEvent = createAsyncThunk('event/toggle-going-event', async (eventId) => {
    try {
        const request = await apiInstance.put(`/api/events/toggle-going-status/${eventId}`);
        const response = request.data
        if (response.status === 'success') {
            return response.goingStatus
        } else {
            throw new Error(response.message)
        }

    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const searchEvent = createAsyncThunk('event/search', async (querry) => {
    try {
        const request = await apiInstance.get(`/api/events/search/search?query=${querry}`);
        const response = request.data
        if (response.status === 'success') {
            return response.data
        }
        else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const removeEventInvitation = createAsyncThunk('event/invitation-remove-event', async (invitationId) => {
    try {
        const request = await apiInstance.delete(`/api/events/invitation/${invitationId}`);
        const response = request.data
        if (response.status === 'success') {
            const res = { message: response.message, invitationId }
            return res
        } else {
            throw new Error(response.message)
        }

    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const inviteUserToEvent = createAsyncThunk('event/invite-user-event', async ({ eventId, invitedUsers }) => {
    try {
        const request = await apiInstance.post(`/api/events/invite/${eventId}`, invitedUsers);
        const response = request.data
        if (response.status === 'success') {
            return response.message
        } else {
            throw new Error(response.message)
        }

    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const getEventCategory = createAsyncThunk('event/category', async (category) => {
    try {
        // console.log(category)
        const request = await apiInstance.get(`/api/events/events/user/${category}`);
        const response = request.data

        if (response.status === 'success') {
            return { category, data: response.data }
        } else {
            throw new Error(response.message)
        }

    }
    catch (error) {
        console.log('something happened; ', error.message)
        throw new Error(error.message)
    }
})

export const deleteEvent = createAsyncThunk('event/delete', async (eventId) => {
    try {
        const request = await apiInstance.delete(`/event/api/cover/${eventId}`);
        const response = request.data;
        if (response.status === 'success') {
            return { eventId, message: response.message };
        } else {
            throw new Error(response.message);
        }
    } catch (error) {
        throw new Error(error.message);
    }
});

export const getPastEvents = createAsyncThunk('event/past-events', async () => {
    try {
        const request = await apiInstance.get('/api/events/past/events');
        const response = request.data;
        if (response.status === 'success') {
            return response.events; // adjust based on actual response structure
        } else {
            throw new Error(response.message);
        }
    } catch (error) {
        throw new Error(error.message);
    }
});
